// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"ku-z","breadcrumbForward":"lu-z","breadcrumbBack":"mu-z","selected":"nu-z"};